import React from "react";
import { Helmet } from "react-helmet";
import "../styles/subpages.css";

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="privacy-section subpage">
      <Helmet>
        <title>Adatkezelési tájékoztató | Autókölcsönző Szolnok</title>
        <meta
          name="description"
          content="Ismerje meg az Autókölcsönző Szolnok adatkezelési tájékoztatóját. Milyen személyes adatokat kezelünk, milyen célból és mennyi ideig."
        />
        <link
          rel="canonical"
          href="https://autokolcsonzoszolnok.hu/adatvedelem"
        />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Adatkezelési tájékoztató | Autókölcsönző Szolnok"
        />
        <meta
          property="og:description"
          content="Részletes adatvédelmi tájékoztató az autokolcsonzoszolnok.hu weboldalon."
        />
        <meta
          property="og:url"
          content="https://autokolcsonzoszolnok.hu/adatvedelem"
        />
        <meta property="og:image" content="/og.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Adatkezelési tájékoztató | Autókölcsönző Szolnok"
        />
        <meta
          name="twitter:description"
          content="Hogyan kezeljük személyes adatait az Autókölcsönző Szolnok weboldalán."
        />
        <meta name="twitter:image" content="/og.png" />
      </Helmet>

      <div className="privacy-policy container mt-1 py-1 text-center d-flex flex-column align-items-center">
        <h1 className="mb-4 pt-5 mt-5">Adatkezelési tájékoztató</h1>

        <p className="w-100">
          Jelen tájékoztató célja, hogy az{" "}
          <strong>autokolcsonzoszolnok.hu</strong> weboldalon megvalósuló
          adatkezelés körülményeit ismertesse a GDPR és az Info tv. előírásai
          alapján.
        </p>

        <div className="subpage-card text-start">
          <h3>1. Adatkezelő adatai</h3>
          <p className="mb-2">
            <strong>Adatkezelő:</strong> Autókölcsönző Szolnok <br />
            <strong>Székhely:</strong> 5000 Szolnok, Kaán Károly út 11. <br />
            <strong>Telefon:</strong>{" "}
            <a href="tel:+36706276599">+36 70 627 65 99</a> <br />
            <strong>E-mail:</strong>{" "}
            <a href="mailto:info@autokolcsonzoszolnok.hu">
              info@autokolcsonzoszolnok.hu
            </a>
          </p>

          <h3>2. Kezelt adatok köre</h3>
          <p>
            Kapcsolatfelvétel, foglalás vagy ajánlatkérés során az alábbi
            adatokat kezelhetjük:
          </p>
          <ul>
            <li>Név</li>
            <li>E-mail cím</li>
            <li>Telefonszám</li>
            <li>Üzenet tartalma</li>
            <li>
              Technikai adatok (IP-cím, böngésző, látogatási idő) – működéshez
              szükséges sütik révén
            </li>
          </ul>

          <h3>3. Az adatkezelés célja és jogalapja</h3>
          <ul>
            <li>
              <strong>Kapcsolattartás és ügyintézés</strong> – jogalap:
              hozzájárulás (GDPR 6. cikk (1) a)).
            </li>
            <li>
              <strong>Ajánlatadás / Foglalás előkészítése</strong> – jogalap:
              szerződés teljesítése előtti lépések (GDPR 6. cikk (1) b)).
            </li>
            <li>
              <strong>Weboldal biztonságos működtetése</strong> – jogalap: jogos
              érdek (GDPR 6. cikk (1) f)).
            </li>
          </ul>

          <h3>4. Megőrzési idő</h3>
          <ul>
            <li>Kapcsolati megkeresések: max. 90 nap.</li>
            <li>
              Technikai naplóadatok: a webszerver működéséhez szükséges ideig.
            </li>
            <li>
              Számlázási/jogi kötelezettség esetén: a vonatkozó jogszabály
              szerinti idő.
            </li>
          </ul>

          <h3>5. Adattovábbítás, adatfeldolgozók</h3>
          <p>
            Adatait nem adjuk át harmadik félnek értékesítési célra. Technikai
            adatkezelést végző szolgáltató:
          </p>
          <p className="mb-2">
            <strong>Amazon Web Services (AWS)</strong> <br />
            Szerep: tárhely- és infrastruktúraszolgáltatás
          </p>

          <h3>6. Érintetti jogok</h3>
          <ul>
            <li>Hozzáférés joga</li>
            <li>Helyesbítés joga</li>
            <li>Törléshez való jog</li>
            <li>Adatkezelés korlátozásának joga</li>
            <li>Adathordozhatóság joga</li>
            <li>Tiltakozás joga</li>
          </ul>

          <h3>7. Jogorvoslati lehetőségek</h3>
          <p>
            Panasszal a Nemzeti Adatvédelmi és Információszabadság Hatósághoz
            (NAIH) fordulhat:
          </p>
          <p className="mb-2">
            <strong>NAIH</strong> <br />
            Cím: 1055 Budapest, Falk Miksa utca 9–11. <br />
            Telefon: +36 (1) 391-1400 <br />
            Web:{" "}
            <a href="https://www.naih.hu" target="_blank" rel="noreferrer">
              www.naih.hu
            </a>
          </p>

          <h3>8. Sütik (cookie-k)</h3>
          <p>
            A weboldal működtetéséhez elengedhetetlen munkamenet-sütiket
            használunk. Nem kötelező, kényelmi célú sütiket csak hozzájárulást
            követően alkalmazunk.
          </p>

          <h3>9. Záró rendelkezések</h3>
          <p>
            Az adatkezelési tájékoztató módosítható; az aktuális verzió a
            weboldalon kerül közzétételre.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
